import { render, staticRenderFns } from "./PatientMedicalReport.vue?vue&type=template&id=15b495dd"
import script from "./PatientMedicalReport.vue?vue&type=script&lang=js"
export * from "./PatientMedicalReport.vue?vue&type=script&lang=js"
import style0 from "./PatientMedicalReport.vue?vue&type=style&index=0&id=15b495dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports